import { CompanyService } from '../services/company.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/company.service";
var CompanyListResolver = /** @class */ (function () {
    function CompanyListResolver(cs) {
        this.cs = cs;
    }
    CompanyListResolver.prototype.resolve = function () {
        return this.cs.getCompanyList();
    };
    CompanyListResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompanyListResolver_Factory() { return new CompanyListResolver(i0.ɵɵinject(i1.CompanyService)); }, token: CompanyListResolver, providedIn: "root" });
    return CompanyListResolver;
}());
export { CompanyListResolver };
